module.exports = __webpack_public_path__ + "img/tern.fe422eb2.svg";